import type { Media } from '../../types/props'

export interface TabWithImageDataItem {
  /** 桌面端图片 URL */
  image: Media
  /** 平板端图片 URL */
  imgPad?: Media
  /** 移动端图片 URL */
  imageMob?: Media
  /** Tab 标题 */
  title: string
}

export interface TabWithImageProps {
  data: {
    /** 主标题 */
    title: string
    /** 副标题（可选） */
    subtitle?: string
    /** 描述文本 */
    desc: string
    /** 默认图片 URL（可选） */
    image?: Media
    /** 默认移动端图片 URL（可选） */
    mobileImage?: Media
    /** 数据列表 */
    datalist: TabWithImageDataItem[]
  }
  /** 自定义类名 */
  className?: string
}
